import { useTranslation } from 'react-i18next'

import { useWidgetContext } from '../../../../../Widget'
import { RentalPortalKeyFactsWidgetItem } from '../../../../RentalPortalKeyFactsWidgetItem'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { getApplicantMatchingRows } from '../ApplicantMatchingWidget.utils'
import { ApplicantMatchingWidgetForm } from '../ApplicantMatchingWidgetForm'

import * as styles from './ApplicantMatchingWidgetContent.module.css'

function ApplicantMatchingWidgetContent() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  return isEditMode ? (
    <ApplicantMatchingWidgetForm
      onClose={handleDisableEditMode}
      onSuccess={handleDisableEditMode}
    />
  ) : (
    <div className={styles.ApplicantMatchingWidgetContent}>
      {getApplicantMatchingRows({ applicantData, t }).map(
        ({ key, label, value }) => (
          <RentalPortalKeyFactsWidgetItem
            key={key}
            label={label}
            value={value}
          />
        )
      )}
    </div>
  )
}

export default ApplicantMatchingWidgetContent
